module.exports = __webpack_public_path__ + "media/images/favicon/favicon-5f973f134aae5cf4325c1a074e605b96.ico";